import { AppPages } from '../../../../../../utilities/app-navigator/src/app-navigator';

export const isActiveIssuesPage = () => {
  // ticket: https://oxsecurity.atlassian.net/browse/OXDEV-23111
  return window.location.pathname === AppPages.ActiveIssues;
};
